<template>
  <div class="billIssued">
    <div class="searchForm">
      <el-date-picker
        v-model="formTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
      <el-button class="search-btn" @click="pageNo = 1 , onSearch()">查询</el-button>
      <el-button class="screen-btn" @click="moreSearch = !moreSearch">
        高级筛选
        <i
          :class="moreSearch ? 'el-icon-arrow-up el-icon--right' : 'el-icon-arrow-down el-icon--right'"
        />
      </el-button>
      <span class="summary">
        <span>
          <!-- <span>单位：</span><span class="redNum company">1</span> -->
          <span>待付金额：</span>
          <span v-if="FPriceShow" class="redNum"><span class="smallIden">￥</span>{{ FWaitTotalAmount.toFixed(2) }}</span>
          <span v-else id="noShowPrice">
            <span style="margin:0;">￥</span>价格不可见
          </span>
        </span>
        <el-button class="export-btn" @click="exportExcel">导出Excel</el-button>
      </span>
      <div v-if="moreSearch" class="moreSearch">
        <el-form ref="form" style="display:flex;" :model="formData" label-width="100px">
          <div>
            <el-form-item label="商品名称:" label-width="80px">
              <el-input v-model="formData.FStockName" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="商品金额:">
              <div style="display:flex;">
                <el-input v-model="formData.FMinAmount" />
                <div style="margin: 0 3px;">
                  -
                </div>
                <el-input v-model="formData.FMaxAmount" />
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单编号:">
              <el-input v-model="formData.FOrderNo" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="所属部门:">
              <el-input v-model="formData.FDepartName" clearable @clear="clearDepart">
                <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true)" />
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单状态:">
              <el-select v-model="formData.FOrderStatus" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!-- <div class="showMoney">
      <span>
        待付款金额：
        <span class="show_box">
          ￥<span class="moneyStatus">{{ showData.FWaitPayAmount }}</span>
        </span>
      </span>
      <span>
        已付款：
        <span class="show_box">
          ￥<span class="moneyStatus">{{ showData.FRepayTotalAmount }}</span>
        </span>
      </span>
      <span>
        付款状态：
        <span v-if="showData.FOverdue === 1" style="color:#EC212D;font-weight: bold;">
          逾期
        </span>
        <span v-if="showData.FOverdue === 0" style="color:#5BD372;font-weight: bold;">
          未逾期
        </span>
      </span>
    </div> -->
    <div class="formTable">
      <el-table
        ref="singleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        border
        fit
        style="width: 100%"
        height="calc(100% - 72px)"
        :header-cell-style="{background:'#EC212D',color:'#fff',fontSize:'16px',fontWeight:'500',textAlign: 'center',height:'60px'}"
        :cell-style="{ textAlign: 'center',height:'66px',background:'#fff' }"
      >
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div class="expand-box">
              <el-table
                v-loading="scope.row.loading"
                :data="scope.row.detail"
                style="width: 100%"
                border
                :header-cell-style="{background:'#ffe1e4',color:'#726361',fontSize:'16px',fontWeight:'500',textAlign: 'left'}"
                :cell-style="{ textAlign: 'left',height:'48px',background:'#fff8f8' }"
              >
                <el-table-column
                  prop="FOrderDate"
                  label="交易日期"
                  show-overflow-tooltip
                />
                <el-table-column
                  prop="name"
                  label="商品名称"
                  width="380"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span style="display: inline-block;width: 35px;">
                      <el-image
                        v-if="scope.row.FStockImagePath"
                        style="width: 35px; height: 35px;vertical-align: middle;"
                        :src="scope.row.FStockImagePath || ''"
                        :preview-src-list="[scope.row.FStockImagePath]"
                      />
                    </span>
                    <span class="stockName" @click="toDetail(scope.row)">
                      {{ scope.row.FStockName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="单价/数量"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <template>
                      <span v-if="FPriceShow" style="font-weight: bold;">
                        <span style="font-size:12px;">￥</span>{{ scope.row.FTotalPrice.toFixed(2) }}
                      </span>
                      <span v-else id="noShowPrice">
                        <span style="margin:0;">￥</span>价格不可见
                      </span>
                      <span style="margin:0 5px;">x</span>
                      <span style="font-weight: bold;">{{ scope.row.FQuanty }}</span>
                      <span v-if="scope.row.FMeasurement">
                        /{{ scope.row.FMeasurement }}
                      </span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="金额"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="FPriceShow" style="font-weight: bold;">
                      <span style="font-size:12px;">￥</span>{{ scope.row.FTotalAmount.toFixed(2) }}
                    </span>
                    <span v-else id="noShowPrice">
                      <span style="margin:0;">￥</span>价格不可见
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="票据状态"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row.FPlatInvoiceStatus == 0 ? '未开票' : scope.row.FPlatInvoiceStatus == 1 ? '已发票' : '无发票' }}
                    /
                    {{ (scope.row.FLogisticsStatus == 6 || scope.row.FLogisticsStatus == 3) ? '已签收' : '未签收' }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="FDepartName"
                  label="所属部门"
                  show-overflow-tooltip
                />
                <el-table-column
                  prop="FRemark"
                  label="明细备注"
                  show-overflow-tooltip
                  sortable
                />
              </el-table>
              <el-pagination
                background
                style="margin-top: 5px;text-align: right;"
                :current-page="scope.row.pageNo"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="scope.row.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="scope.row.total"
                @size-change="detailSizeChange(scope.row,$event)"
                @current-change="detailCurrentChange(scope.row,$event)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          show-overflow-tooltip
        />
        <el-table-column
          property="FTitle"
          label="账单编号"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#EC212D;text-decoration:underline;">
              {{ scope.row.FTitle }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FBillAmount"
          label="账单金额"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- color:#EC212D; -->
            <span v-if="FPriceShow" style="font-weight: bold;">
              <span style="font-size:12px;">￥</span>{{ scope.row.FBillAmount }}
            </span>
            <span v-else id="noShowPrice">
              <span style="margin:0;">￥</span>价格不可见
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          property="FRepayAmount"
          label="已付金额"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- color:#EC212D; -->
            <span v-if="FPriceShow" style="font-weight: bold;">
              <span style="font-size:12px;">￥</span>{{ scope.row.FRepayAmount | fixMoney }}
            </span>
            <span v-else id="noShowPrice">
              <span style="margin:0;">￥</span>价格不可见
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          property="FWaitPayAmount"
          label="待付金额"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <!-- color:#EC212D; -->
            <span v-if="FPriceShow" style="font-weight: bold;">
              <span style="font-size:12px;">￥</span>{{ scope.row.FWaitPayAmount | fixMoney }}
            </span>
            <span v-else id="noShowPrice">
              <span style="margin:0;">￥</span>价格不可见
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FBillStates"
          label="付款状态"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span :style="scope.row.FBillStates == 0 ? 'color: #EC212D;' : ''">
              {{ billStatus[scope.row.FBillStates] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FDueDate"
          label="付款日"
          show-overflow-tooltip
        />
        <el-table-column
          property="FOverDays"
          label="逾期天数"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#EC212D;">
              {{ scope.row.FOverDays }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FWaitTotalAmount"
          label="账单明细"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#EC212D;cursor: pointer;">
              <!-- {{ scope.row.FWaitTotalAmount }} -->
              <span @click="expandTable(scope.$index,scope.row)">
                账单明细<i style="margin-left:5px;" :class="scope.row.isOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-left'" />
              </span>
            </span>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
        style="text-align: right;margin-top:20px;"
        background
        layout="total , sizes, prev, pager, next , jumper"
        :page-sizes="[50, 100, 500]"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="onSearch"
      />
    </div>
    <tree
      ref="depart"
      title="所属部门"
      label="FName"
      parent-id="FParentID"
      :tree-visible="searchVisible"
      :default-arr="defaultArr"
      search-url="/mall/mallmanage/billapprovalinfo/getDepartInfo"
      @treeConfirm="cfmSearch"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import tree from '@/components/tree/tree.vue'
export default {
  components: {
    tree
  },
  filters: {
    fixMoney(val) {
      if (val) {
        return val.toFixed(2)
      } else {
        return '0.00'
      }
    }
  },
  data() {
    return {
      defaultArr: [],
      showData: {
        FRepayTotalAmount: '',
        FWaitPayAmount: '',
        FOverdue: ''
      },
      dimension: '1',
      loading: false,
      searchVisible: false,
      moreSearch: false,
      formTime: [],
      formData: {
        FBeginOrderDate: '',
        FEndOrderDate: '',
        FStockName: '',
        FMinAmount: '',
        FMaxAmount: '',
        FOrderNo: '',
        FTreeCode: '',
        FDepartName: '',
        FOrderStatus: -1
      },
      options: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 0,
          label: '未完成'
        },
        {
          value: 1,
          label: '已完成'
        },
        {
          value: 2,
          label: '已退货'
        }
      ],
      pageNo: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      excelLoading: null,
      FWaitTotalAmount: 0.00,
      billStatus: {
        0: '逾期',
        1: '未结清',
        2: '已结清',
        '-1': '未知'
      },
      FPriceShow: 0
    }
  },
  watch: {
    // tableData: {
    //   handler(val) {
    //     console.log(val)
    //   },
    //   deep: true
    // }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    var date = new Date()
    var dayS = date.getDate()
    var month = parseInt(date.getMonth() + 1)
    if (month < 10) {
      month = '0' + month
    }
    if (dayS < 10) {
      dayS = '0' + dayS
    }
    date.setDate(1)
    this.formTime[0] = this.getSixMonth()
    this.formTime[1] = date.getFullYear() + '-' + month + '-' + dayS
    this.onSearch()
  },
  methods: {
    getSixMonth() {
      const dt = new Date()
      dt.setMonth(dt.getMonth() - 6)
      //   HH:MM
      return (this.dateFormat('YYYY-mm-dd', new Date(dt.getTime()))).slice(0, 8) + '01'
    },
    dateFormat(fmt, date) {
      let ret
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (const k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        }
      }
      return fmt
    },
    toDetail(item) {
      const routeUrl = this.$router.resolve({
        name: 'MyOrderManagement',
        query: {
          FBillID: item.FBillID
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    detailSizeChange(row, val) {
      row.pageSize = val
      this.getDetail(row)
    },
    detailCurrentChange(row, val) {
      row.pageNo = val
      this.getDetail(row)
    },
    expandTable(i, row) {
      row.isOpen = !row.isOpen
      const els = this.$refs.singleTable.$refs.bodyWrapper.querySelectorAll('.el-table__expand-column .el-table__expand-icon')
      els[i] && els[i].click()
      if (row.isOpen) {
        // const line = document.getElementById('createdLine')
        // line && line.remove()
        this.getDetail(row, true)
        // this.$nextTick(() => {
        //   this.addLine()
        // })
      }
    },
    getDetail(row, n) {
      row.loading = true
      if (n) {
        row.pageNo = 1
        row.pageSize = 10
      }
      const params = new URLSearchParams()
      params.append('pageNo', row.pageNo)
      params.append('pageSize', row.pageSize)
      params.append('fTotalBillID', row.FID)
      const data = JSON.parse(JSON.stringify(this.getFormData()))
      data.FBeginDate = row.FBeginDate.slice(0, 10)
      data.FEndDate = row.FEndDate.slice(0, 10)
      data.FDueDate = row.FDueDate
      data.FTitle = row.FTitle
      params.append('jsonobj', JSON.stringify(data))
      request({
        url: '/mall/demand/userCenter/demandOutBillDetail',
        method: 'post',
        params
      })
        .then(res => {
          this.$set(row, 'detail', res.data.records)
          this.$set(row, 'total', res.data.total)
          this.$set(row, 'loading', false)
        })
        .catch(() => {
          this.$set(row, 'loading', false)
        })
    },
    exportExcel() {
      this.excelLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/excel/export/demandOutBill',
        method: 'post',
        params,
        responseType: 'blob'
      })
        .then(res => {
          if (!res.data.size) {
            this.excelLoading.close()
            this.$message.warning('没有可导出的数据')
            return
          }
          const content = res.data // 文件流
          const blob = new Blob([content], { type: 'application/vdn.ms-excel' })
          const contentDisposition = res.headers['content-disposition']
          const fileName = decodeURI(contentDisposition.split('=')[1])
          if ('download' in document.createElement('a')) { // 非IE下载
            const link = document.createElement('a')
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.excelLoading.close()
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
            this.excelLoading.close()
          }
        })
        .catch(() => {
          this.excelLoading.close()
        })
    },
    getFormData() {
      const jsonobj = JSON.parse(JSON.stringify(this.formData))
      if (this.formTime !== null && this.formTime.length) {
        jsonobj.FBeginOrderDate = this.formTime[0]
        jsonobj.FEndOrderDate = this.formTime[1]
      }
      jsonobj.FMinAmount = jsonobj.FMinAmount === '' ? -1 : Number(jsonobj.FMinAmount)
      jsonobj.FMaxAmount = jsonobj.FMaxAmount === '' ? -1 : Number(jsonobj.FMaxAmount)
      delete jsonobj.FDepartName
      return jsonobj
    },
    // getSumBill() {
    //   const params = new URLSearchParams()
    //   params.append('jsonobj', JSON.stringify(this.getFormData()))
    //   request({
    //     url: '/mall/demand/userCenter/sumBill',
    //     method: 'post',
    //     params
    //   })
    //     .then(res => {
    //       if (res.data) {
    //         this.showData = res.data
    //       }
    //     })
    // },
    addLine() {
      const trs = this.$refs.singleTable.$refs.bodyWrapper.querySelectorAll('.el-table__row')
      const start = this.pageSize * (this.pageNo - 1)
      const end = this.pageSize * this.pageNo
      const arr = this.tableData.slice(start, end)
      let b = true
      arr.forEach((t, i) => {
        if (t.FBillStates == 2 && i !== 0 && b) {
          const div = document.createElement('div')
          div.setAttribute('id', 'createdLine')
          div.style.borderTop = '2px dashed #747174'
          div.style.margin = '10px 0'
          div.style.width = window.getComputedStyle(trs[i].parentNode).width
          trs[i].parentNode.insertBefore(div, trs[i])
          trs[i].querySelectorAll('td').forEach(t => {
            t.style.borderTop = '1px solid #EBEEF5'
          })
          b = false
          return
        }
      })
    },
    onSearch() {
      this.loading = true
      const line = document.getElementById('createdLine')
      line && line.remove()
      const params = new URLSearchParams()
      params.append('pageNo', this.pageNo)
      params.append('pageSize', this.pageSize)
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/queryDemandOutBill',
        method: 'post',
        params
      })
        .then(res => {
          this.FWaitTotalAmount = res.data.FWaitTotalAmount
          res.data.PageList.records.length && res.data.PageList.records.map(item => {
            this.$set(item, 'detail', [])
            this.$set(item, 'loading', false)
            this.$set(item, 'pageNo', 1)
            this.$set(item, 'pageSize', 10)
            this.$set(item, 'total', 0)
            this.$set(item, 'isOpen', false)
          })
          this.tableData = res.data.PageList.records
          this.total = res.data.PageList.total
          if (this.tableData.length > 1) {
            this.$nextTick(() => {
              this.addLine()
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    cfmSearch(val, arr) {
      this.defaultArr = val ? [val.fid] : ''
      this.formData.FTreeCode = val ? val.FTreeCode : ''
      this.formData.FDepartName = val ? val.FName : ''
      this.searchVisible = false
    },
    clearDepart() {
      this.formData.FTreeCode = this.formData.FDepartName = ''
      this.defaultArr = []
      this.$refs.depart.clear()
    },
    selectDeparment(val) {
      !val && this.$refs.depart.clear()
      this.searchVisible = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    }
  }
}
</script>

<style lang="scss">
.billIssued {
    height: calc(100vh - 112px);
    .stockName {
        cursor: pointer;
        text-decoration: underline;
    }
    .stockName:hover {
        color: #ec212d !important;
    }
    // .el-table__expand-column {
    //     display: none;
    // }
    // .el-table tr:hover {
    //     .el-table__expanded-cell {
    //         background: #fff8fa;
    //     }
    // }
    // .el-table__expanded-cell {
    //     background: #fff8fa;
    //     :hover {
    //         background: #fff8fa;
    //     }
    // }
    .expand-box {
        // background: #fff8fa;
        padding: 0px 15px;
        .el-table__body-wrapper {
            max-height: 205px;
            overflow-y: auto;
        }
        .el-table--fit {
            border: 2px solid #f1a6a6;
            // border-bottom: 0;
        }
        .el-table th.el-table__cell.is-leaf, .el-table td.el-table__cell {
            border-bottom: 1px solid #f1a6a6 !important;
            border-right: 1px solid #f1a6a6 !important;
        }
    }
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .showMoney {
        height: 68px;
        line-height: 68px;
        font-size: 16px;
        color: #666666;
        font-weight: 500;
        .show_box {
            display: inline-block;
            min-width: 100px;
            color: #EC212D;
            font-weight: bold;
        }
        .moneyStatus {
            font-size: 22px;
        }

    }
    .searchForm {
        margin-bottom: 10px;
        .summary {
            display: flex;
            height: 41px;
            float: right;
            // line-height: 41px;
            >span {
                height: 41px;
                display: flex;
                align-items: center;
            }
            // span {
            //     display: inline-block;
            // }
            .redNum {
                min-width: 60px;
                padding-right: 10px;
                color: #EC212D;
                font-size: 24px;
                font-weight: 600;
                height: 28px;
                line-height: 28px;
            }
            .company {
                color: #000;
            }
            .smallIden {
                color: #EC212D;
                font-weight: 600;
                font-size: 12px;
            }
        }
        .export-btn {
            height: 40px;
            background: #EC212D;
            color: #fff;
            float: right;
            width: 97px;
            margin-left: 32px;
        }
        .search-btn {
            width: 72px;
            height: 40px;
            background: #EC212D;
            color: #fff;
            margin-left: 32px;
        }
        .screen-btn {
            width: 124px;
            height: 40px;
            background: #F5F5F5;
            color: #666666;
            margin-left: 32px;
        }
        .moreSearch {
            height: 60px;
            background: #F5F5F5;
            margin-top: 10px;
            padding: 10px 0;
            .el-form>div {
                width: 20%;
            }
            .el-form-item__label {
                font-size: 16px;
                color: #8C909C;
                font-weight: 400;
            }
        }
    }

}
</style>
